var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { getMarketplace } from 'src/utils/marketplace';
// Function to ensure consistency of query key accross the application
export const getAppInitQueryKey = (marketplaceId) => ['getAppInit', marketplaceId];
export const useAppInit = (options) => {
    var _a;
    const enabled = (_a = options === null || options === void 0 ? void 0 : options.enabled) !== null && _a !== void 0 ? _a : true;
    const [searchParams] = useSearchParams();
    const marketplaceId = getMarketplace(searchParams);
    return useQuery({
        queryKey: getAppInitQueryKey(marketplaceId),
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () { return yield HandshakePainterServiceApiV1.initApp({ marketplaceId }); }),
        staleTime: Infinity, // Data stays fresh for the entire session
        enabled,
    });
};
